import { useState } from 'react';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ currentLang, onLanguageChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { 
      code: 'en', 
      label: 'EN', 
      flag: 'https://flagcdn.com/w40/us.png',
      flagAlt: 'US Flag'
    },
    { 
      code: 'fr', 
      label: 'FR', 
      flag: 'https://flagcdn.com/w40/fr.png',
      flagAlt: 'France Flag'
    },
  ];

  const currentLanguage = languages.find(lang => lang.code === currentLang);

  const handleSelect = (code) => {
    onLanguageChange(code);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher">
      <div className={`language-switcher__dropdown ${isOpen ? 'language-switcher__dropdown--open' : ''}`}>
        {languages.filter(lang => lang.code !== currentLang).map((lang) => (
          <button
            key={lang.code}
            className="language-switcher__option"
            onClick={() => handleSelect(lang.code)}
          >
            <img src={lang.flag} alt={lang.flagAlt} className="language-switcher__flag" />
            <span className="language-switcher__label">{lang.label}</span>
          </button>
        ))}
      </div>
      <button 
        className="language-switcher__toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select language"
      >
        <img src={currentLanguage?.flag} alt={currentLanguage?.flagAlt} className="language-switcher__flag" />
        <span className="language-switcher__label">{currentLanguage?.label}</span>
        <span className={`language-switcher__arrow ${isOpen ? 'language-switcher__arrow--up' : ''}`}>
          <svg viewBox="0 0 320 512" width="10" height="10">
            <path fill="currentColor" d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"/>
          </svg>
        </span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
